import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Upsell() {
  return <Section background="light" data-id="element-343">
      <FadeIn data-id="element-344">
        <div className="bg-[#1B4332] rounded-2xl p-8 md:p-12 text-white relative overflow-hidden" data-id="element-345">
          {/* Decorative circle */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-346" />

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8" data-id="element-347">
            <div className="flex-shrink-0 bg-white/10 p-4 rounded-full" data-id="element-348">
              <ShieldCheck className="h-10 w-10 text-[#D8F3DC]" data-id="element-349" />
            </div>

            <div className="text-center md:text-left" data-id="element-350">
              <h3 className="text-2xl font-bold mb-3 font-serif" data-id="element-351">
                Soporte adicional (Opcional)
              </h3>
              <p className="text-[#D8F3DC] mb-4 leading-relaxed" data-id="element-352">
                Si sentís que te falta confianza para caminar o salir, una{' '}
                <strong data-id="element-353">rodillera de compresión</strong> puede funcionar como
                soporte: te da sensación de estabilidad mientras hacés el
                protocolo.
              </p>
              <p className="text-sm text-white/70 italic" data-id="element-354">
                No reemplaza el plan. Te acompaña mientras construís la base.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}